export default __webpack_public_path__ + "static/3-2b42b96a4d2d8b6f821e7e213dd92365.webp";